import React from 'react';
import { Box, Flex, Link, Text, UseDisclosureReturn } from '@chakra-ui/react';
import { LoadingModal } from './atoms/modal/loadingmodal';
import { themeVariables } from '../theme';
interface TransactionInProgressProps {
  disc: UseDisclosureReturn;
  title?: string;
  description?: string;
  isSwap?: boolean;
  background?: string;
}

export const TransactionInProgress: React.FC<TransactionInProgressProps> = ({
  title = 'Metera Order in Progress',
  description = 'Confirm the transaction in your wallet',
  isSwap,
  background,
}) => (
  <Flex
    flexDir="column"
    gap="2rem"
    minHeight="264px"
    align="center"
    justify="center"
    padding={'24px'}
    background={background ? background : themeVariables.background.modal}
    borderRadius="10px"
    width={'100%'}
    color={themeVariables.offWhite.offWhite400}
  >
    <Flex
      flexDir="column"
      gap="1rem"
      align="center"
      justify="center"
      padding={'24px'}
      borderRadius="0.75rem"
      width={'100%'}
      cursor="default"
    >
      <Text
        fontSize="18px"
        fontWeight="500"
        lineHeight="28px"
        textAlign="center"
      >
        {title}
      </Text>
      <Flex>
        {isSwap ? (
          <Flex flexDir="column" width="25rem" gap="1rem">
            {/* <StepGuide hasBorder step="1" /> todo: add stepguide to library */}
            <Flex
              justify="center"
              color={themeVariables.neutral[400]}
              fontSize="16px"
              fontWeight={400}
              lineHeight="24px"
              textAlign="center"
            >
              {description}
            </Flex>
          </Flex>
        ) : (
          <Flex
            justify="center"
            color={themeVariables.neutral[400]}
            fontSize="16px"
            fontWeight={400}
            lineHeight="24px"
            textAlign="center"
          >
            {description}
          </Flex>
        )}
      </Flex>
    </Flex>
    <Flex
      fontSize="12px"
      fontWeight={400}
      lineHeight="20px"
      textAlign="left"
      gap={1}
    >
      <Text as={'span'}>Do you need help?</Text>
      <Link
        href={'https://discord.com/invite/Ws5Z5ZACme'}
        color={themeVariables.purple.button100}
        target="blank"
      >
        Contact support
      </Link>
    </Flex>
  </Flex>
);

function TransactionInProgressModal(props: TransactionInProgressProps) {
  return (
    <LoadingModal {...props.disc} minWidth="376px" minHeight="274px">
      <TransactionInProgress
        title={props.title}
        description={props.description}
        isSwap={props.isSwap}
      />
    </LoadingModal>
  );
}

export default TransactionInProgressModal;
